const GA_EVENTS = {
    WITH_COMPS_WITH_ZESTIMATE: {
        category: 'ZRM_price_my_rental',
        label: 'comps_and_zestimate',
        action: 'success',
        description: 'Successfully returns comps and Zestimate.',
    },
    WITH_COMPS_WITH_OUT_ZESTIMATE: {
        category: 'ZRM_price_my_rental',
        label: 'comps_no_zestimate',
        action: 'success',
        description: 'Successfully returns comps without a Zestimate.',
    },
    CANNOT_FIND_ADDRESS: {
        category: 'ZRM_price_my_rental',
        label: 'no_zpid',
        action: 'error',
        description: 'Cannot find address.',
    },
    CANNOT_FIND_COMPS: {
        category: 'ZRM_price_my_rental',
        label: 'no_comps',
        action: 'error',
        description: 'Cannot find comparables.',
    },
};

const PriceRentalsConstants = { GA_EVENTS };

export default PriceRentalsConstants;
